( function ($) {

  function initSection ( $section ) {
    if ( $( '> .slide', $section ).length > 1 ) {
      let autoSpeed = $section.data( 'autospeed' );
      autoSpeed = parseInt( autoSpeed );
      autoSpeed = isNaN( autoSpeed ) ? 0 : autoSpeed;
      autoSpeed = autoSpeed || 6;
      const autoPlay = ( autoSpeed === -1 ) ? false : true;
      $section.slick({
        slide: '.slide',
        rows: 0,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: autoPlay,
        autoplaySpeed: autoSpeed * 1000,
        arrows: false,
        dots: true,
        appendDots: $section.find( '.dot-wrap' ),
        customPaging: function ( slider, i ) {
          return $('<button>').addClass( `btn` ).html( $( '<span>' ).addClass( 'sr-only' ).text( i + 1 ) );
        },
      });
    }
    $section.addClass( 'initialized' );
  }

  $( function () {
    $( '.banner-2026' ).each( function () {
      initSection( $(this) );
    });
  });
  

})( jQuery );